export default function (params) {
  return {
    justifyContent: 'flex-end',
  }
}
